<template>
    <div>
        <template v-for="(embeddedModule, index) in embeddedModules || []">
            <embedded-module-component
                :state="state"
                :config="Object.keys(embeddedModule.config || {}).length > 0 ? embeddedModule.config : {}"
                :event-bus="eventBus"
                :icon-class="embeddedModule.iconClass"
                :row="row"
                :query="Object.keys(embeddedModule.query || {}).length > 0 ? embeddedModule.query : {}"
                :target="embeddedModule.target"
                :title="embeddedModule.title"
                :url="embeddedModule.url"
            ></embedded-module-component>
        </template>
        <span v-if="displayValue">{{ row[column.data] }}</span>
    </div>
</template>

<script>

import EmbeddedModuleComponent from "./EmbeddedModuleComponent";
import ValueChecker from "../../services/ValueChecker";

export default
{
    components: {EmbeddedModuleComponent},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    showValue: true,
                }
            },
        },
        column: {
            type: Object,
        },
        embeddedModules: {
            type: Array
        },
        eventBus: {
            type: Object,
        },
        state: {
            type: Object
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {

        };
    },
    computed: {
        displayValue() {
            let defaultDisplayValue = this.config.showValue;

            if (ValueChecker.isUndefinedOrNull(this.config.showValue)) {
                defaultDisplayValue = true;
            }

            return !ValueChecker.isUndefinedOrNull(this.row[this.column.data]) && defaultDisplayValue;
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// EmbeddedModulesComponent.vue?b0eaa96e